import { render, staticRenderFns } from "./migalha.vue?vue&type=template&id=357b12d8"
import script from "./migalha.vue?vue&type=script&lang=js"
export * from "./migalha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports